<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-text>
          <modalDialog :width="'80%'" ref="rptfm" :show="show_rpt" :pers="true">
            <template v-slot:header-actions>
              <v-btn @click.stop="closeRForm()" icon style="cursor:pointer">
                <v-icon>close</v-icon>
              </v-btn>
            </template>

            <template v-slot:content>
              <div style="text-align:center">
                <h2>{{settings.school.school_name}}</h2>
                <h3>{{report_model.rpt_type?report_model.rpt_type:""}} Report</h3>
                <h4>{{selectedAcyearName}}-{{selectedTermName}}</h4>
              </div>
              <!-- summary report begins -->
              <v-card style="margin-bottom:10px" v-if="report_model.rpt_type=='Summary'" flat>
                <v-card-title>Summary</v-card-title>
                <v-card-text>
                  <div style="text-align:center">
                    <p>Cash At Bank: {{banking?banking.cash_at_bank:0 | toCurrency}}</p>
                    <p>Revenue (Fees Payments + Other Incomes): {{revenue?revenue.feespayment_sum+revenue.income_sum:0 | toCurrency}}</p>
                    <p>Expenses: {{expenses?expenses.expense_sum:0 | toCurrency}}</p>
                    <br />

                    <!-- <p
                      style="font-style:italic;color:#333"
                    >**NOTE: Accounts Receivable is already part of Revenue and Accounts Payable is already part of expenses**</p>-->
                    <p v-if="isCurrentTerm">Accounts Receivable(Fees In Arrears): {{revenue.arrears_sum | toCurrency}}</p>
                    <!-- <p>Accounts Payable: GHS {{expenses_data&&expenses_data.ov_expense_payable?expenses_data.ov_expense_payable:0 | toCurrency}}</p> -->

                    <!-- <p>Net Revenue: GHS {{revenue_data?(revenue_data.credit_sale_sum+revenue_data.cash_sale_sum)  - expenses_data.ov_expense:0 | toCurrency}}</p>
                    -->
                  </div>
                </v-card-text>
              </v-card>
              <!-- summary report ends -->

              <!-- revenue report begins -->
              <v-card v-if="report_model.rpt_type=='Revenue'" flat>
                <v-card-title>Total Revenue ({{revenue.feespayment_sum+revenue.income_sum | toCurrency}})</v-card-title>
                <v-card-text style="margin:0">
                  <div style="page-break-after: always;">
                    <h3
                      style="text-align:center"
                    >Fees Payments({{revenue.feespayment_sum | toCurrency}})</h3>
                    <v-data-table
                      :headers="isCurrentTerm?feepayment_headers:feepayment_headers2"
                      :items="revenue.all_feepayments"
                      class="elevation-0 mb-6"
                      :disable-pagination="true"
                      :hide-actions="true"
                    >
                      <template v-slot:items="props">
                        <td class="text-xs-center">{{ props.item.rollno}}</td>
                        <td class="text-xs-center">{{ props.item.s_bio.name }}</td>
                        <td class="text-xs-center">{{ props.item.s_class.name }}</td>
                        <td v-if="isCurrentTerm" class="text-xs-center">{{ props.item.tot_bill | toCurrency }}</td>
                        <!-- <td class="text-xs-center">{{ props.item.amt_tendered | toCurrency }}</td>
                        <td class="text-xs-center">{{ props.item.change_due | toCurrency }}</td>-->
                        <!-- <td class="text-xs-center">{{ props.item.mop }}</td> -->
                        <td class="text-xs-center">{{ props.item.tot_paid | toCurrency }}</td>
                        <td v-if="isCurrentTerm" class="text-xs-center">{{ props.item.remaining_fee | toCurrency }}</td>
                        <!-- <td
                          class="text-xs-center"
                        >{{ props.item.cust_name?props.item.cust_name + '('+props.item.cust_phone+')' : 'N/A' }}</td>
                        <td
                          class="text-xs-center"
                        >{{ moment(new Date(props.item.created_at)).format('DD-MM-YYYY @ h:mm:ss A') }}</td>-->
                      </template>
                    </v-data-table>
                  </div>

                  <div style="page-break-after: always;">
                    <h3
                      style="text-align:center"
                    >Other Incomes ({{ revenue.income_sum | toCurrency}})</h3>
                    <v-data-table
                      :headers="inc_headers"
                      :items="revenue.incomes"
                      class="elevation-0 mb-4"
                      :disable-pagination="true"
                      :hide-actions="true"
                    >
                      <template v-slot:items="props">
                        <!-- <td class="text-xs-center">{{ props.index + 1 }}</td> -->
                        <td
                          class="text-xs-center"
                        >{{ props.item.ledgeracc&&props.item.ledgeracc.name?props.item.ledgeracc.name:'N/A' }}</td>
                        <td class="text-xs-center">{{ props.item.description }}</td>
                        <td class="text-xs-center">{{ props.item.amount | toCurrency }}</td>
                        <td class="text-xs-center">{{ props.item.jdate }}</td>
                        <td class="text-xs-center">{{ props.item.recorded_by.name }}</td>
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
              <!-- revenue report ends -->

              <!-- expense report begins -->
              <v-card v-if="report_model.rpt_type=='Expense'" flat>
                <v-card-title>Expense</v-card-title>
                <v-card-text style="margin:0">
                  <div style="page-break-after: always;margin-bottom:10px;">
                    <h3 style="text-align:center">Grouped Expense Summaries</h3>
                    <v-data-table
                      :headers="exsum_headers"
                      :items="expenses.expla_summaries"
                      class="elevation-0"
                      :disable-pagination="true"
                      :hide-actions="true"
                    >
                      <template v-slot:items="props">
                        <td class="text-xs-center">{{ props.index + 1 }}</td>
                        <td
                          class="text-xs-center"
                        >{{ props.item.ledgeracc?props.item.ledgeracc:'N/A' }}</td>
                        <td class="text-xs-center">{{ props.item.amount | toCurrency}}</td>
                      </template>
                    </v-data-table>
                  </div>
                  <div style="page-break-after: always;">
                    <h3
                      style="text-align:center"
                    >All Expenses ({{expenses.expense_sum | toCurrency}})</h3>
                    <v-data-table
                      :headers="exp_headers"
                      :items="expenses.all_expenses"
                      class="elevation-0"
                      :disable-pagination="true"
                      :hide-actions="true"
                    >
                      <template v-slot:items="props">
                        <td class="text-xs-center">{{ props.index + 1 }}</td>
                        <td
                          class="text-xs-center"
                        >{{ props.item.ledgeracc&&props.item.ledgeracc.name?props.item.ledgeracc.name:'N/A' }}</td>
                        <td class="text-xs-center">{{ props.item.description }}</td>
                        <td class="text-xs-center">{{ props.item.amount | toCurrency }}</td>
                        <td class="text-xs-center">{{ props.item.jdate }}</td>
                        <td class="text-xs-center">{{ props.item.recorded_by.name }}</td>
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
              <!-- expense report ends -->

              <!-- banking report begins -->
              <v-card v-if="report_model.rpt_type=='Banking'" flat>
                <v-card-title>Banking</v-card-title>
                <v-card-text style="margin:0">
                  <div style="page-break-after: always;margin-bottom:10px;">
                    <h3 style="text-align:center">Grouped Bank Acct. Trans. Summaries</h3>
                    <v-data-table
                      :headers="banksum_headers"
                      :items="banking.bacc_summaries"
                      class="elevation-0"
                      :disable-pagination="true"
                      :hide-actions="true"
                    >
                      <template v-slot:items="props">
                        <td class="text-xs-center">{{ props.index + 1 }}</td>
                        <td class="text-xs-center">{{ props.item.bankacc?props.item.bankacc:'N/A' }}</td>
                        <td class="text-xs-center">{{ props.item.dr | toCurrency}}</td>
                        <td class="text-xs-center">{{ props.item.cr | toCurrency}}</td>
                        <td class="text-xs-center">{{ props.item.balance | toCurrency}}</td>
                      </template>
                    </v-data-table>
                  </div>
                  <div style="page-break-after: always;">
                    <h3 style="text-align:center">All Bank Transactions</h3>

                    <v-data-table
                      :headers="bank_trans_headers"
                      :items="banking.all_transactions"
                      class="elevation-0"
                      :loading="rptloading"
                      :disable-pagination="true"
                      :hide-actions="true"
                    >
                      <template v-slot:items="props">
                        <td
                          class="text-xs-center"
                        >{{ props.item.bankacc&&props.item.bankacc.bank_name?props.item.bankacc.bank_name+' ('+props.item.bankacc.acc_num+')':'N/A' }}</td>
                        <td class="text-xs-center">{{ props.item.tran_type }}</td>
                        <td class="text-xs-center">{{ props.item.amount | toCurrency }}</td>
                        <td class="text-xs-center">{{ props.item.tdate}}</td>
                        <td class="text-xs-center">{{ props.item.description }}</td>
                        <td
                          class="text-xs-center"
                        >{{ props.item.recorded_by&&props.item.recorded_by.name?props.item.recorded_by.name:'N/A' }}</td>
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
              <!-- banking report ends -->
            </template>

            <template v-slot:footer-actions>
              <!-- <v-btn class="error" flat @click.stop="closeRForm()">Close</v-btn> -->
              <v-btn style="cursor:pointer" color="success" icon @click="print('rptnView')">
                <v-icon>print</v-icon>
              </v-btn>
            </template>
          </modalDialog>

          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-card>
                <v-card-title>
                  <h4>Report Builder</h4>
                </v-card-title>
                <v-card-text>
                  <v-form ref="rptform">
                    <v-layout row wrap>
                      <!-- title -->
                      <v-flex xs12>
                        <v-autocomplete
                          label="Report Type"
                          :items="['Summary','Revenue','Expense','Banking']"
                          outline
                          v-model="report_model.rpt_type"
                          :rules="rules.required"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                          label="Academic Year"
                          :items="acyears"
                          item-text="name"
                          item-value="id"
                          outline
                          v-model="report_model.acyear"
                          :rules="rules.required"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                          label="Term"
                          :items="terms"
                          item-text="name"
                          item-value="id"
                          outline
                          v-model="report_model.term"
                          :rules="rules.required"
                        ></v-autocomplete>
                      </v-flex>
                      <!-- <v-flex xs12>
                        <v-dialog
                          ref="rptDtdialog1"
                          v-model="rptdt1Modal"
                          :return-value.sync="report_model.from"
                          persistent
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="report_model.from"
                              label="From:"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                              :rules="rules.required"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="report_model.from" scrollable>
                            <div class="flex-grow-1"></div>
                            <v-btn text color="primary" @click="rptdt1Modal = false">Cancel</v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.rptDtdialog1.save(report_model.from)"
                            >OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12>
                        <v-dialog
                          ref="rptDtdialog2"
                          v-model="rptdt2Modal"
                          :return-value.sync="report_model.to"
                          persistent
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="report_model.to"
                              label="To:"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                              :rules="rules.required"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="report_model.to" scrollable>
                            <div class="flex-grow-1"></div>
                            <v-btn text color="primary" @click="rptdt2Modal = false">Cancel</v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.rptDtdialog2.save(report_model.to)"
                            >OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>-->
                    </v-layout>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click="generateRpt()">Generate</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import modalDialog from "../../../components/RptModal";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    modalDialog
  },

  data() {
    return {
      valid: true,
      lazy: false,
      show1: false,

      dialog: false,
      show_rpt: false,
      moment: moment,
      rules: {
        required: [value => !!value || "Required."]
      },
      all_set: false,
      inc_headers: [
        {
          text: "Ledger Account",
          align: "center",
          sortable: false,
          value: "ledgeracc.name"
        },
        {
          text: "Description",
          align: "center",
          sortable: false,
          value: "description"
        },
        {
          text: "Amount",
          align: "center",
          sortable: true,
          value: "amount"
        },
        {
          text: "Date",
          align: "center",
          sortable: false,
          value: "jdate"
        },
        {
          text: "Recorded By",
          align: "center",
          sortable: false,
          value: "recorded_by.name"
        }
      ],

      feepayment_headers: [
        {
          text: "Roll. No.",
          align: "center",
          sortable: false,
          value: "rollno"
        },
        {
          text: "Student Name",
          align: "center",
          sortable: true,
          value: "s_bio.name"
        },
        {
          text: "Class",
          align: "center",
          sortable: true,
          value: "s_class.name"
        },
        {
          text: "Current Bill",
          align: "center",
          sortable: false,
          value: "amount"
        },
        {
          text: "Total Paid",
          align: "center",
          sortable: false,
          value: "date"
        },
        {
          text: "Arrears",
          align: "center",
          sortable: false,
          value: "remaining_fees"
        }
      ],
      feepayment_headers2: [
        {
          text: "Roll. No.",
          align: "center",
          sortable: false,
          value: "rollno"
        },
        {
          text: "Student Name",
          align: "center",
          sortable: true,
          value: "s_bio.name"
        },
        {
          text: "Class",
          align: "center",
          sortable: true,
          value: "s_class.name"
        },

        {
          text: "Total Paid",
          align: "center",
          sortable: false,
          value: "date"
        }
      ],
      bank_trans_headers: [
        {
          text: "Bank Acct.",
          align: "center",
          sortable: false,
          value: "acc_name"
        },
        {
          text: "Trans. Type",
          align: "center",
          sortable: false,
          value: "trans_type"
        },
        {
          text: "Amount",
          align: "center",
          sortable: false,
          value: "amount"
        },
        {
          text: "Trans. Date",
          align: "center",
          sortable: false,
          value: "tdate"
        },
        {
          text: "Description/Ref",
          align: "center",
          sortable: false,
          value: "description"
        },
        {
          text: "Recorded By",
          align: "center",
          sortable: false,
          value: "recorded_by.name"
        }
      ],

      exp_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Ledger Account",
          align: "center",
          sortable: false,
          value: "expense.name"
        },
        {
          text: "Description/Ref.",
          align: "center",
          sortable: false,
          value: "description"
        },
        {
          text: "Amount(GHS)",
          align: "center",
          sortable: false,
          value: "amount"
        },
        {
          text: "Date",
          align: "center",
          sortable: false,
          value: "jdate"
        },
        {
          text: "Recorded By",
          align: "center",
          sortable: false,
          value: "recorded_by.name"
        }
      ],
      exsum_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Exp. Ledger Account",
          align: "center",
          sortable: false,
          value: "ledgeracc.name"
        },
        {
          text: "Amount",
          align: "center",
          sortable: false,
          value: "amount"
        }
      ],
      banksum_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Bank Account",
          align: "center",
          sortable: false,
          value: "bankacc.name"
        },
        {
          text: "Total Debit(dr)",
          align: "center",
          sortable: false,
          value: "dr"
        },
        {
          text: "Total Credit(cr)",
          align: "center",
          sortable: false,
          value: "cr"
        },
        {
          text: "Current Balance",
          align: "center",
          sortable: false,
          value: "balance"
        }
      ],

      rptdt1Modal: false, //report date 1 modal
      rptdt2Modal: false, //report date 2 modal
      report_model: {
        rpt_type: "",
        acyear: "",
        term: ""
      }
    };
  },
  created() {
    this.$store.dispatch("settings/getAll");
    this.$store.dispatch("terms/getAll");
    this.$store.dispatch("academicYear/getAll");
    this.$store.dispatch("billings/getAll");

    console.log(this.settings)
  },
  computed: {
    ...mapGetters({
      acyears: "academicYear/ACYEARS",

      settings: "settings/SETTINGS",

      terms: "terms/TERMS",

      revenue: "reports/REVENUERPT",
      expenses: "reports/EXPENSESRPT",
      banking: "reports/BANKINGRPT",
      rptloading: "reports/RPT_LOADING",

      current_user: "Auth/CURRENT_USER"
    }),

    selectedAcyearName() {
      if (this.report_model.acyear) {
        let ayobj = this.acyears.find(x => {
          return x.id == this.report_model.acyear;
        });

        return ayobj.name;
      }

      return "";
    },
    selectedTermName() {
      if (this.report_model.term) {
        let tobj = this.terms.find(x => {
          return x.id == this.report_model.term;
        });

        return tobj.name;
      }

      return "";
    },
    isCurrentTerm(){
      if(this.settings.ayt.acyear.id==this.report_model.acyear && this.settings.ayt.term.id==this.report_model.term){
        return true
      }
      return false
    }
  },

  watch: {
    show_rpt(val) {
      if (val && val == false) {
        // this.revenue_data = {
        //   all_sales: {},
        //   cash_sale_sum: 0,
        //   credit_sale_sum: 0,
        //   credit_payments_sum: 0,
        //   vendor_sale_sums: [] //vendor  sale sums (vcass)
        // };
        this.report_model = {
          rpt_type: "",
          acyear: "",
          term: ""
        };
      }
    }
  },
  methods: {
    closeRForm() {
      this.show_rpt = false;
    },

    pad(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    },

    async generateRpt() {
      // this.show_rpt = true;
      // return;
      if (this.$refs.rptform.validate()) {
        if (this.report_model.rpt_type == "Summary") {
          this.$store.dispatch("reports/getRevenueRpt", this.report_model);
          this.$store.dispatch("reports/getExpensesRpt", this.report_model);
          this.$store.dispatch("reports/getBankingRpt", this.report_model);

          if (this.banking && this.revenue && this.expenses) {
            this.show_rpt = true;
          }
        } else if (this.report_model.rpt_type == "Revenue") {
          await this.$store.dispatch(
            "reports/getRevenueRpt",
            this.report_model
          );
          if (this.revenue) {
            this.show_rpt = true;
          }
        } else if (this.report_model.rpt_type == "Expense") {
          await this.$store.dispatch(
            "reports/getExpensesRpt",
            this.report_model
          );

          if (this.expenses) {
            this.show_rpt = true;
          }
        } else if (this.report_model.rpt_type == "Banking") {
          await this.$store.dispatch(
            "reports/getBankingRpt",
            this.report_model
          );
          if (this.banking) {
            this.show_rpt = true;
          }
        }
        // alert("poowww..your report");
      }
    },

    print(doc) {
      //window.print();
      //this.$htmlToPaper('printMe');

      // Get HTML to print from element
      const prtHtml = document.getElementById(doc).innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }

      var toPrint = `<!DOCTYPE html>
<html>
  <head></head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
  <style>
    .v-table thead th {
      white-space:normal!important
    }

  </style>
</html>`;

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(toPrint);

      WinPrint.document.close();
      WinPrint.focus();

      if (WinPrint.document.readyState === "complete") {
        setTimeout(function() {
          WinPrint.print();
          WinPrint.close();
        }, 1300);
      }

      //WinPrint.print();
      //WinPrint.close();
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/accountant/reports/report.vue